import { motion } from 'framer-motion';
import React from 'react';
export default function GlobalSpinner(props) {
    var url = "/images/loading.gif";
    if (props.site == "pursuit") {
        // INFO: Remove loading image for now for pursuit
        url = "/images/pursuit/loading.gif";
        return React.createElement(motion.div, { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true }, className: "text-center global-spinner", style: { position: "fixed", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", "zIndex": 99999 } });
    }
    return (React.createElement(motion.div, { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true }, className: "text-center global-spinner", style: { position: "fixed", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", "zIndex": 99999 } },
        React.createElement("img", { src: url, alt: "Loading ..." })));
}
